import React, { useState } from 'react'
import { DownloadScholarshipsModal } from 'components'
import styled, { css } from 'styled-components'
import { Card, Row, Col } from 'react-bootstrap'
import dataImage from 'images/get-data.png'
import { CustomLinks } from 'components'

const GetDataPage = () => {
  const [showDownload, setShowDownload] = useState(false);
  const handleDownload = (e) => {
    e.preventDefault()
    setShowDownload(true)
  }

  return (
    <Container>
      <Row className="justify-content-md-center">
        <Col md="auto" className="mb-4 mr-4">
          <Card>
            <CardImage variant="top" />
            <Card.Body>
              <Card.Title>Get Your Data</Card.Title>
              <Card.Text>
                <small className="text-muted">
                  Download your organization's data
                </small>
                <br />
                <small className="font-weight-light">
                  Get your organization's data as a downloadable file. You can
                  choose from Excel or JSON.
                </small>
              </Card.Text>
            </Card.Body>
            <Card.Body>
              <Card.Link href="#" onClick={handleDownload}>
                Download Excel
              </Card.Link>
              <Card.Link className="ml-2">Download JSON</Card.Link>
            </Card.Body>
          </Card>
        </Col>
        <Col md="auto">
          <Card>
            <CardImage variant="top" second="true" />
            <Card.Body>
              <Card.Title>Get NSPA Exchange Data</Card.Title>
              <Card.Text>
                <small className="text-muted">
                  Download data files from the NSPA
                </small>
                <br />
                <small  className="font-weight-light">
                  Did you know that the NSPA provides downloadable datasets of
                  scholarship and organization information?
                </small>
              </Card.Text>
            </Card.Body>
            <Card.Body>
              <CustomLinks location="GET_DATA.FIND_OUT_MORE"/>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}/>
      </Row>
      {showDownload && (
        <DownloadScholarshipsModal show onHide={() => setShowDownload(false)} />
      )}
    </Container>
  )
}

const CardImage = styled(Card.Img)`
  background-image: url(${dataImage});
  height: 141px;
  background-size: 540px;

  ${({ second }) =>
    second &&
    css`
      background-position: 269px 0;
      background-size: 539px 140px;
    `}
`

const Container = styled.div`
  margin-top: 1rem;
  padding: 3rem;
  height: 100%;
  font-size: 0.9rem;

  .card {
    width: 17rem;

    .card-title {
      color: ${({ theme }) => theme.palette.primary[0]};
      font-size: 1.2rem;
    }

    a:not([href]) {
      color: ${({ theme }) => theme.palette.grayscale[3]};
      text-decoration: none;
    }

    p {
      margin-bottom: 0;
    }
  }
`

export default GetDataPage
